// extracted by mini-css-extract-plugin
export default {"asciiContainer":"ascii_asciiContainer__aGFOe","asciiArt":"ascii_asciiArt__VdaNf"};